import { createSelector } from '@reduxjs/toolkit';
import type { FavoriteState } from './favoritesSlice';

export const getFavorites = (state: { favorites: FavoriteState }) => state.favorites.favorites;

export const getMessageFavorite = (messageId: string) =>
  createSelector(getFavorites, (favorites) => {
    return favorites.find((fav) => fav.messageId === messageId);
  });
